import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';

import filmApplicationFConsider from './filmApplicationsForConsider.js';

// const btnExport =  document.querySelector('#filmAFConsider').querySelector('button[name=excelExport]');
// const aExport =  document.querySelector('#filmAFConsider').querySelector('a[name=excelExport]');

// const exportBody = document.querySelector('#excelExportFIELD');
// // excelExportFIELD

// const exFilmsCard = document.querySelector('#filmsExport_card');
// const exFilmsCardAllInputs = exFilmsCard.querySelectorAll('input[type="checkbox"]');
// const exFilmsCardAlTypeData = exFilmsCard.querySelectorAll('input[type="radio"]');
// const exFilmsCardAllInputFilms = exFilmsCard.querySelector('div[name=page_films]').querySelectorAll('input');
// const exFilmsCardAllInputFilmCreators = exFilmsCard.querySelector('div[name=page_creators]').querySelectorAll('input');

const bodyPDF = document.querySelector('#PDFExportFIELD');

const viewExportPDF = document.querySelector('#viewExportPDF')

const btExpoertAll = viewExportPDF.querySelector('button[name=generate');
const exFilmsCardAlTypeData = viewExportPDF.querySelectorAll('input[name="typeFilmsExport"]');

const cardConsider = document.querySelector('#filmConsider_card');
const filmCardBtMakePdf = cardConsider.querySelector('button[name=btn_exportPDF]');
let countImgLoaded = 0;
let allPosts = null;
let curCompetitionType = 0;


btExpoertAll.addEventListener('click', function () {
  // alert();
  makePDFByCompetitonType(getCurrentTypeSourceData());
});



function getCurrentTypeSourceData () {
  let returnValue = 0;
  exFilmsCardAlTypeData.forEach((element) => {
    if(element.checked)
      returnValue =  parseInt(element.value, 10);
    
  });
  return returnValue;
}


filmCardBtMakePdf.addEventListener('click', function () {
      let oneFilmArr = [{}];
      oneFilmArr[0].nomination = clearNomination(cardConsider.querySelector('b[name=fest-nomination]').innerHTML);
      oneFilmArr[0].img = cardConsider.querySelector('div[name=frames]').children[0].querySelector('img').src;
      oneFilmArr[0].imgSecond = cardConsider.querySelector('div[name=frames]').children[1].querySelector('img').src;
      oneFilmArr[0].name = cardConsider.querySelector('b[name=film-name]').innerHTML;
      oneFilmArr[0].serial = cardConsider.querySelector('b[name=film-serial]').innerHTML;
      oneFilmArr[0].desc = cardConsider.querySelector('p[name=film-description]').innerHTML;

      let allCloudsHTml = '';
      let allClouds = cardConsider.querySelector('div[name=Clouds]').querySelectorAll('div[alt=Техника]');
      allClouds.forEach((cElem) => {
            allCloudsHTml += removeIconInHTML(cElem.innerHTML) + ', ';
      });
      allCloudsHTml += removeIconInHTML(cardConsider.querySelector('div[name=Clouds]').querySelector('div[alt="Продолжительность"]').innerHTML);
      allCloudsHTml += ', ';
      if(cardConsider.querySelector('div[name=studio]').querySelector('b')){
            allCloudsHTml += cardConsider.querySelector('div[name=studio]').querySelector('b').innerHTML;
            allCloudsHTml += ', ';
      }
      allCloudsHTml += removeIconInHTML(cardConsider.querySelector('div[name=Clouds]').querySelector('div[alt="Год производства"]').innerHTML);

      oneFilmArr[0].detail = allCloudsHTml;

      oneFilmArr[0].crew = removeButtonInCrewHTML(cardConsider.querySelector('div[name=crew]').innerHTML);

      let allRejHTML = [];
      let allRej = cardConsider.querySelectorAll('.mainRejCard');
      allRej.forEach((rElem) => {
            let dctRej = {};
            dctRej.img = rElem.querySelector('img').src;
            let fullName = '';
            rElem.querySelectorAll('b').forEach((elem) => {
              fullName += elem.innerHTML + ' ';
            });

            dctRej.name = fullName;
            dctRej.desc = rElem.querySelectorAll('p')[0].innerHTML;
            dctRej.byear = rElem.querySelectorAll('.bYear')[0].innerHTML;
            dctRej.bplace = rElem.querySelectorAll('.bPlace')[0].innerHTML;

            allRejHTML.push(dctRej);
      });
      oneFilmArr[0].rej = allRejHTML;
      // console.log(oneFilmArr);
      makePDFFilms(oneFilmArr);
});
function clearNomination(nomName){
  let indexLeftBracket = nomName.indexOf('(');
  if(indexLeftBracket > 0)
    return nomName.substr(0, indexLeftBracket);
  else 
    return nomName;
}
function removeIconInHTML(htmlCode){
      let indexIMG = htmlCode.indexOf('>');
      return htmlCode.substring(indexIMG + 1);
}

function removeButtonInCrewHTML(htmlCode){
   
      // let currentPost =  htmlCode.substring(0, indexBT);
      let allPeople = htmlCode.split('</button>');
      let postBefore = '';
      let rStr = '';
      allPeople.forEach((pElement) => {
            let indexBT = pElement.indexOf('<button');

            let newStr = pElement.substring(0, indexBT);
            newStr = newStr.replace('<br>','');
            indexBT =  newStr.indexOf(':');
            let currentPost = newStr.substring(0, indexBT);
            if(currentPost === postBefore)
                  rStr += ', ' + removeAllSpaces(newStr.substring(indexBT + 1));
            else {
                  postBefore = currentPost;
                  rStr += '<br>' +removeAllSpaces(newStr);
            }
            
      });

      return rStr;

   // let indexBT = htmlCode.indexOf('<button');
   //    let indexbtEnd = htmlCode.indexOf('</button');
   //    let countLoop = 0;

   //    do {
   //          ++countLoop;
   //          htmlCode = htmlCode.substring(0, indexBT) + htmlCode.substring(indexbtEnd + 9);
   //          indexBT = htmlCode.indexOf('<button');
   //          indexbtEnd = htmlCode.indexOf('</button>');

   //    } while(indexBT > 1 && countLoop < 100);

   //    return htmlCode;
}
// 
function checkNull(nValue){
  if(nValue)
    return nValue;
  else
    return '';
}
function removeAllSpaces(strWithSpace) {
  strWithSpace = strWithSpace.replace(' <b', '<b')
  strWithSpace = strWithSpace.replace(':', ': ');
  strWithSpace = strWithSpace.replace('</b> ', '</b>');
//   strWithSpace = strWithSpace.replace(' ', '');
  return strWithSpace;

}
function makePDFFilms(arrFilms){
  bodyClear();
  if(arrFilms)
        arrFilms.forEach((fElement) => {
              bodyAddOneFilmPage(fElement);
        });

  globalAddImgListener();

 
}

function makePDFByCompetitonType(type){
  if(confirm('При первом формирование PDF  файла - процедура может занимать более одной минуты.\n\nДождитесь окончания!\n\n Не закрывайте сайт и не переходите в другие блоки.\nПродолжительность процедуры зависит от количетсва картинок, которых необходимо загрузить. \n\n Начать формирование PDF?')){
    viewExportPDF.querySelector('div[name=countDownloadImg]').innerHTML = 'Запрос данных';
    bodyClear();
    curCompetitionType = type;
    if(allPosts)
      makePDFByCompetitonTypeWithPost(type);
    else
      xhr.request = {
        metod: 'GET',
        url: 'posts',
        data: '',
        callbackSuccess: onSuccessPotsLoad
      }
  }
}
const onSuccessPotsLoad = (servAnswer) => {
  if (servAnswer.status === 200){
    allPosts = servAnswer.data; 
    makePDFByCompetitonTypeWithPost(curCompetitionType);
  }
};

function makePDFByCompetitonTypeWithPost(type){
    let allFileds = "\"order_number_request\", \"serial_title\", \"about\", \"time_h_m_sec\", \"year\", \"year_limit\", \"techs\", \"country\", \"twoframes\",  \"typeFilm\", \"studio\", \"applicant_contact_info_email\", \"nomination\", \"creator_page_fio\", \"creator_page_bio\", \"creator_page_year\",\"creator_page_b_place\"";
    xhr.request = {
            metod: 'POST',
            url: `festival/${auth.currentFestival}/exportExcel/`,
            data: `sort=films&fields=[${allFileds}]&data=requestFilms&step=0&FilmsRequestStatus=2&FilmsRequestType=${type}`,
            callbackSuccess: onSuccessLoadExportData
          };
}

const onSuccessLoadExportData = (servarAnswer) => {
  if (servarAnswer.status === 200) {
    servarAnswer.data.forEach((sElement) => {
      // console.log(sElement);
      let oneFilmArr = {};
      oneFilmArr.nomination = clearNomination(sElement.nomination);

      oneFilmArr.img = 'https://festcontent.ru/films/' + sElement.twoFrames[0] + '.jpg';
      oneFilmArr.imgSecond = 'https://festcontent.ru/films/' + sElement.twoFrames[1] + '.jpg';
      oneFilmArr.name = sElement.title;
      oneFilmArr.serial = sElement.serial;
      oneFilmArr.desc = sElement.about;

      let allCloudsHTml = '';
      allCloudsHTml += sElement.studio;
      allCloudsHTml += ', ';
      allCloudsHTml += sElement.techs;
      allCloudsHTml += ', ';

      // let allClouds = cardConsider.querySelector('div[name=Clouds]').querySelectorAll('div[alt=Техника]');
      // allClouds.forEach((cElem) => {
      //       allCloudsHTml += removeIconInHTML(cElem.innerHTML) + ', ';
      // });
      let longSec = parseInt(sElement.time_sec, 10);
      let hours = Math.floor(longSec/(60*60));
      longSec -= hours * 60*60;
      let minutes = Math.floor((longSec%(60*60))/60 );
      let sec = longSec % 60;

      if(minutes < 10)
        minutes = `0${minutes}`;
      if(sec < 10)
        sec = `0${sec}`;

      allCloudsHTml += `${hours}:${minutes}:${sec}`;


      allCloudsHTml += ', ';
       allCloudsHTml += sElement.country;
      allCloudsHTml += ', ';
      // if(cardConsider.querySelector('div[name=studio]').querySelector('b')){
      //       allCloudsHTml += cardConsider.querySelector('div[name=studio]').querySelector('b').innerHTML;
      //       allCloudsHTml += ', ';
      // }
      
      
     
      allCloudsHTml += sElement.year;

      oneFilmArr.detail = allCloudsHTml;

      oneFilmArr.crew = removeButtonInCrewHTML(displayCrew(sElement.crew));

      let allRejHTML = [];

      sElement.creatorPage.forEach((rElem) => {
            let dctRej = {};
            dctRej.img = 'https://festcontent.ru/creators/' + rElem.image + '.jpg';
            dctRej.name = checkNull(rElem.nameF) + ' ' + checkNull(rElem.nameI) + ' ' + checkNull(rElem.nameO);
            dctRej.desc = checkNull(rElem.bio);
            dctRej.byear = checkNull(rElem.bYear);
            dctRej.bplace = checkNull(rElem.bPlace);

            allRejHTML.push(dctRej);
      });
      oneFilmArr.rej = allRejHTML;

      bodyAddOneFilmPage(oneFilmArr);
      // allFilms.push(oneFilmArr);

    });

    globalAddImgListener();
    // globalAddImgListener();
  }
};

function bodyClear (){
  bodyPDF.innerHTML = '';
}
function globalAddImgListener () {
  
  let allImg = bodyPDF.querySelectorAll('img[name=loadImgSuccessDone]');
  if(allImg)
    imgSrc2(allImg[0]);

}
function imgSrc2(img){
  img.addEventListener('load', function (evt) { 
    let allImg = bodyPDF.querySelectorAll('img[name=loadImgSuccessDone]');
    viewExportPDF.querySelector('div[name=countDownloadImg]').innerHTML = 'Осталось загрузить картинок: ' + allImg.length;
    if(allImg && allImg.length > 0)
      imgSrc2(allImg[0]);
    else
        makePDF();
  });

  if (img.attributes.src2 && img.attributes.src2.nodeValue !== 'https://festcontent.ru/films/undefined.jpg' && img.attributes.src2.nodeValue !== 'https://festcontent.ru/creators/undefined.jpg') {
    console.log(img.attributes.src2.nodeValue);
    img.src = img.attributes.src2.nodeValue;
    img.removeAttribute('src2');
    img.removeAttribute('name');
  } else{
    img.removeAttribute('src2');
    img.removeAttribute('name');
    let allImg = bodyPDF.querySelectorAll('img[name=loadImgSuccessDone]');
    if(allImg && allImg.length > 0)
      imgSrc2(allImg[0]);
    else
        makePDF()
  }
}
function bodyAddOneFilmPage (dataFilms) {
      let rowRej = '';
      dataFilms.rej.forEach((rElem) => {
            rowRej += `<div class="rowRej "> 
                              <div style="margin:0px; padding:10px; width:30%;">
                                  <img src2="${rElem.img}" style="max-width: 100%; max-height:100%;" name=loadImgSuccessDone>
                              </div>

                              <div style="margin:0px; padding:10px; width:70%;" class="column">
                                <b>${rElem.name}</b>
                                <p>${rElem.desc}</p>    
                                <div class="rowRej">
                                  <div style="margin-right:20px;">${rElem.byear}</div>
                                  <div style="margin-right:20px;">${rElem.bplace}</div>
                                </div>
                              </div>
                        </div>`;
      });
      // dataFilms  - словарь с атрибутами 
      let nameSerial = '';
      if(dataFilms.serial)
        nameSerial = dataFilms.serial + ' : ';
      // <h4 class=" txt-al-center pdf-w-100">${dataFilms.nomination}</h4>//
      //pagebreak  - использовать только когда много страниц
      let htlmBody = `<div style="min-height:100%; width:100%; margin:0px; padding:0px; " class=" pagebreak">
                        <h4 class=" txt-al-center pdf-w-100" style="margin:0px; padding-bottom:6px;">${dataFilms.nomination}</h4>
                        <div class="rowRej "> 
                          <img src2="${dataFilms.img.replace('_preview_300','')}" name=loadImgSuccessDone  class="pdf-w-100 filmImage">
                          <img src2="${dataFilms.imgSecond.replace('_preview_300','')}" name=loadImgSuccessDone  class="pdf-w-100 filmImage">

                        </div>
                        <h2 class="pdf-w-100 txt-al-center padding:10px;">${nameSerial}${dataFilms.name}</h2>
                        <p style="font-size:14px;">${dataFilms.desc}</p>
                        <div style="padding:40px 30px; background:white; font-size:14px;" class="column">
                              <i>${dataFilms.detail}</i>
                              <span style="margin-top: 10px;">${dataFilms.crew}</span>
                        </div>
                        <div style="margin-top:auto; margin-bottom:0px" class="dontbreak">
                              ${rowRej}
                        </div>
                  </div>`;

      bodyPDF.innerHTML += htlmBody;

}
  function displayCrew(currentCrew) {
    let allCreatorsHTML = '';
    if(currentCrew)
      JSON.parse(currentCrew).forEach((element) => {
        allCreatorsHTML += `${searchPost(element.id)}: <b name="crew" class="mt-1">${element.name}</b> <button> </button><br>`;
      });
    return allCreatorsHTML;
  }


  function searchPost(postID) {
    let postName = '';
    allPosts.forEach((element) => {
      if (parseInt(postID, 10) === parseInt(element.id, 10))
        postName = element.name;
      
    });
    return postName;
  }



function makePDF() {
      // alert('345');
      // let bodyPDFHTML = bodyPDF.html();
      // console.log($("#PDFExportFIELD").html());
      let printWindow = window.open('', '', 'height=400,width=800');
      // printWindow.document.write('<html><head><title>Экспорт PDF</title><link type="text/css" rel="stylesheet" href="https://festapp.ru/public-css/pdf.css?v=4"></head><body>');
     
      printWindow.document.write('<html><head><title>Экспорт PDF</title>');
      printWindow.document.write(`
  <style type="text/css">
      .pdf-w-100{
      /*width: 400px;*/
      display: block;
}
@media print {
      .rowRej {
            break-inside: avoid;
      }
      .pagebreak {
        clear: both;
        page-break-after: always;
      }
      .dontbreak{
      page-break-inside: avoid !important;
      margin-bottom: 20px;
    }

}
    .dontbreak{
      page-break-inside: avoid !important;
      margin-bottom: 20px;
    }

.filmImage{
  margin-left: auto;
  margin-right: auto;
  width: 45%;
}
.rowRej{
      page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
      page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
      page-break-inside: avoid; /* or 'auto' */
      display: flex;
      flex-direction: row; 
      margin:0; 
      padding 0px;
}
.column{
      display: flex; 
      flex-direction:column;
}

img{
      max-height: 280px;
      margin-left: auto;
      margin-right: auto;
      object-fit: contain;
      border-radius: 4px;
        page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
    page-break-inside: avoid; /* or 'auto' */
}

.txt-al-center {
      text-align: center;
}

p{ 
      font-size: 14px;
    text-indent: 1.5em; /* Отступ первой строки */
    text-align: justify; /* Выравнивание по ширине */
}
span{
      font-size: 14px;
}</style>`);
      printWindow.document.write($("#PDFExportFIELD").html());
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
};

export default {

  export(){
    makeExport();

  },
  makePDFByCompetitonType(type){
    makePDFByCompetitonType(type);
  },

  stop() {
    // pointsMarkup.cleanContainer();
  }
};
